import type { ColumnVisibilityItem } from '@/components/common/ColumnVisibility/ColumnVisibility';

/** Options for the column visibility menu: the name column is always listed first and cannot be hidden. */
export function getColumnVisibilityOptions(
  labels: Record<string, string>,
  hideableColumnIds: string[],
  isVisible: (columnId: string) => boolean
): ColumnVisibilityItem[] {
  return [
    { disabled: true, id: 'name', label: labels.name, visible: true },
    ...hideableColumnIds.map(id => ({ id, label: labels[id], visible: isVisible(id) }))
  ];
}
